import { render, staticRenderFns } from "./AMSDialog.vue?vue&type=template&id=58f9b5f8&scoped=true&"
import script from "./AMSDialog.vue?vue&type=script&lang=js&"
export * from "./AMSDialog.vue?vue&type=script&lang=js&"
import style0 from "./AMSDialog.vue?vue&type=style&index=0&id=58f9b5f8&scoped=true&lang=css&"
import style1 from "./AMSDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f9b5f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VDialog,VFlex,VIcon,VLayout})
